// src/brand/useDocumentMeta.js
// Dependency-free per-route <title>/description/OG updates (no react-helmet).
// public/index.html keeps the BoardWatch defaults as the neutral first paint;
// this hook overrides them at runtime for the active brand/route.
import { useEffect } from "react";

function setMeta(selector, attr, value) {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [, key, name] = selector.match(/\[(\w+)="([^"]+)"\]/) || [];
    if (key && name) el.setAttribute(key, name);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

export function useDocumentMeta({ title, description }) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    return () => {
      document.title = prevTitle;
    };
  }, [title, description]);
}
